import React from 'react'

export default function FormSection({ title, description, icon: Icon, stepNumber, children, className = '' }) {
  return (
    <div className={`space-y-5 ${className}`}>
      {(title || description) && (
        <div className="flex items-start gap-3">
          {/* Step number or icon */}
          {stepNumber ? (
            <div className="flex-shrink-0 mt-0.5">
              <div className="flex items-center justify-center h-8 w-8 rounded-full
                bg-primary-100 dark:bg-primary-100 text-primary-700 dark:text-primary-600
                text-sm font-bold ring-2 ring-primary-50 dark:ring-primary-50">
                {stepNumber}
              </div>
            </div>
          ) : Icon ? (
            <div className="flex-shrink-0 mt-0.5">
              <div className="flex items-center justify-center h-9 w-9 rounded-xl
                bg-primary-50 dark:bg-primary-50 text-primary-600 dark:text-primary-500">
                <Icon className="h-5 w-5" />
              </div>
            </div>
          ) : null}
          <div className="min-w-0">
            {title && (
              <h3 className="text-base font-bold text-text leading-tight">{title}</h3>
            )}
            {description && (
              <p className="text-sm text-text-muted mt-0.5 leading-relaxed">{description}</p>
            )}
          </div>
        </div>
      )}
      <div className="space-y-4">
        {children}
      </div>
    </div>
  )
}
